var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.003 0.5H11.997C5.3805 0.5 0 5.882 0 12.5C0 15.125 0.846 17.558 2.2845 19.5335L0.789 23.9915L5.4015 22.517C7.299 23.774 9.5625 24.5 12.003 24.5C18.6195 24.5 24 19.1165 24 12.5C24 5.8835 18.6195 0.5 12.003 0.5Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9848 17.4455C18.6953 18.263 17.5463 18.941 16.6298 19.139C16.0028 19.2725 15.1838 19.379 12.4268 18.236C8.90034 16.775 6.62934 13.1915 6.45234 12.959C6.28284 12.7265 5.02734 11.0615 5.02734 9.33953C5.02734 7.61753 5.90184 6.77903 6.25434 6.41903C6.54384 6.12353 7.02234 5.98853 7.48134 5.98853C7.62984 5.98853 7.76334 5.99603 7.88334 6.00203C8.23584 6.01703 8.41284 6.03803 8.64534 6.59453C8.93484 7.29203 9.63984 9.01403 9.72384 9.19103C9.80934 9.36803 9.89484 9.60803 9.77484 9.84053C9.66234 10.0805 9.56334 10.187 9.38634 10.391C9.20934 10.595 9.04134 10.751 8.86434 10.97C8.70234 11.1605 8.51934 11.3645 8.72334 11.717C8.92734 12.062 9.63234 13.2125 10.6703 14.1365C12.0098 15.329 13.0958 15.71 13.4843 15.872C13.7738 15.992 14.1188 15.9635 14.3303 15.7385C14.5988 15.449 14.9303 14.969 15.2678 14.4965C15.5078 14.1575 15.8108 14.1155 16.1288 14.2355C16.4528 14.348 18.1673 15.1955 18.5198 15.371C18.8723 15.548 19.1048 15.632 19.1903 15.7805C19.2743 15.929 19.2743 16.6265 18.9848 17.4455Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp1);
export default __webpack_public_path__ + "static/media/whatsapp 1.7cc30eddaac78fbadb0861624dcd2876.svg";
export { ForwardRef as ReactComponent };